import isArray from "lodash/isArray.js";
import lowerCase from "lodash/lowerCase.js";
import moment from "moment";

import { dateFilters } from "@evolved/constants";

const { OPTIONS } = dateFilters;
const VALID_RELATIVE_TENSES = ["PAST", "OLDER", "FUTURE", "LATER"];
const VALID_RELATIVE_UNITS = ["DAY", "DAYS", "WEEK", "WEEKS", "MONTH", "MONTHS", "YEAR", "YEARS"];

const isTimestampRange = (filter) => {
  return (
    isArray(filter) &&
    filter.length === 2 &&
    filter.every((value) => typeof value === "number")
  );
};

const isMomentRange = (value, start, end) => {
  return value.isBetween(start, end);
};

export const filter = (value, filter) => {
  const m = typeof value === "number" ? moment.unix(value) : moment(value);

  if (isTimestampRange(filter)) {
    return isMomentRange(m, moment.unix(filter[0]), moment.unix(filter[1]));
  }

  const [tense, quantity, unit] = filter.split("_");

  if (tense === "FUTUREYM") {
    // quantity = YEAR
    // unit = MONTH
    return isMomentRange(
      m,
      moment().year(quantity).month(unit).startOf("month"),
      moment().year(quantity).month(unit).endOf("month")
    );
  }

  const amount = Number(quantity);
  const normalizedUnit = lowerCase(unit);

  if (tense === "FUTURE") {
    return isMomentRange(m, moment(), moment().add(amount, normalizedUnit));
  }

  if (tense === "LATER") {
    return m.isAfter(moment().add(amount, normalizedUnit));
  }

  if (tense === "OLDER") {
    return m.isBefore(moment().subtract(amount, normalizedUnit));
  }

  return isMomentRange(m, moment().subtract(amount, normalizedUnit), moment());
};

export const validate = (filter) => {
  if (isTimestampRange(filter)) {
    return true;
  }

  if (typeof filter !== "string") {
    return false;
  }

  if (Object.keys(OPTIONS).includes(filter)) {
    return true;
  }

  const [tense, quantity, unit] = filter.split("_");

  if (tense === "FUTUREYM") {
    return Boolean(quantity) && Boolean(unit);
  }

  const amount = Number(quantity);

  if (
    VALID_RELATIVE_TENSES.includes(tense) &&
    Number.isInteger(amount) &&
    amount > 0 &&
    VALID_RELATIVE_UNITS.includes(unit)
  ) {
    return true;
  }

  return false;
};
